<!-- HM footer logo - standard HIPAAMATE footer with logo -->
<template>
  <div class="pt-3 text-center text-muted">
    <a :href="'https://' + config.WebDomain + '/'">
      <img class="logo-account" src="img/logo-white-wide.svg" />
    </a>
    <div class="small pt-2">
      &copy; 2018-2022 All Rights Reserved.
      <a href="https://www.hipaamate.com/legal/privacy" target="_blank"
        >Privacy Policy</a
      >
      and
      <a href="https://www.hipaamate.com/legal/terms" target="_blank"
        >Terms of Service</a
      >
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "HMFooterLogo",
  data() {
    return {};
  },
  computed: {
    ...mapState(["config"])
  }
};
</script>

<style lang="scss" scoped>
// import variables for this application
@import "@/assets/scss/_variables.scss";

.logo-account {
  max-width: 175px;
  max-height: 175px;
  white-space: nowrap;
  text-align: center;
  background: #adb5bd;
}
</style>
